import { startPerformanceMeasure } from '@vend/utilities'
import { useCallback } from 'react'
import {
  useCustomerManager,
  useIsCalculatingSale,
  useTrainingModeManager,
  useWorkflowsManager,
} from '../../../../ng-compat/hooks'
import { useAppDispatch, useAppSelector } from '../../../../state/hooks'
import {
  finalisingSale,
  finalisingSaleComplete,
  workflowsStarted,
} from '../../../../state/slices/uiStateSlice'
import { selectSaleCustomer } from '../../../../state/slices/currentSale/currentSaleSlice'
import { isValidCustomer } from '../../../../functions/sale'
import { $state } from '../../../../ng-compat/imports'
import { STATES } from '../../../../../../lib/routes'
import { useCanTransitionToPaymentScreen } from './use-can-transition-to-payment-screen'

export const useTransitionToPaymentScreen = (
  lspayQuickPaySelected?: boolean
) => {
  const dispatch = useAppDispatch()
  const trainingModeManager = useTrainingModeManager()
  const customerManager = useCustomerManager()
  const workflowsManager = useWorkflowsManager()
  const customer = useAppSelector(selectSaleCustomer)
  const canTransitionToPaymentScreen = useCanTransitionToPaymentScreen()
  const isCalculating = useIsCalculatingSale()

  return useCallback(() => {
    if (!canTransitionToPaymentScreen || isCalculating) {
      return
    }

    dispatch(finalisingSale)

    if (!trainingModeManager.trainingModeEnabled) {
      // time how long it takes to tender a sale
      startPerformanceMeasure('sale-process')
      // start timing how long it takes to initiate a sale with a payment type
      startPerformanceMeasure('select-payment-type-process')
    }

    const customerRefreshPromise = isValidCustomer(customer)
      ? customerManager.refreshCustomer(customer)
      : Promise.resolve()

    customerRefreshPromise
      .then(() => {
        dispatch(workflowsStarted)
        return workflowsManager.readyForPayment({
          element: document.getElementById('wr-pay-button')!,
          placement: 'top',
        })
      })
      .then((proceed: boolean) => {
        if (proceed) {
          $state.go(STATES.PAYMENT, {
            lspayQuickPaySelected,
          })
        }
      })
      .finally(() => {
        dispatch(finalisingSaleComplete)
      })
  }, [
    canTransitionToPaymentScreen,
    customer,
    customerManager,
    dispatch,
    isCalculating,
    lspayQuickPaySelected,
    trainingModeManager.trainingModeEnabled,
    workflowsManager,
  ])
}
